import React from "react";
import ShowSearch from "./show_search";
import { languages } from "../../../constants/language-choices";
import {
  AudienceSize,
  AverageCPM,
  EpisodeSize,
  Image,
  renderToContext,
  SpotRate,
  TitleContainer,
} from "../tables/campaign_show_list_table";
import { CampaignDistributionReachDiscrete } from "../../../constants/campaigns";
const AdvertiserSearch = ({
  extraFilterOptions,
  additionalFilters,
  campaign,
  additionalColumns,
  ...props
}) => {
  const getColumns = () => {
    const commonColumns = [
      {
        title: "Category",
        render: renderToContext(
          <div className={"flex-row-container align-center"}>
            <Image />
            <TitleContainer campaign={campaign} />
          </div>
        ),
        width: 450,
        filterDropdown: "categoryUUIDs",
      },
    ];

    const continuousColumns = [
      {
        title: "Weekly Downloads",
        render: renderToContext(<AudienceSize />),
        filterDropdown: "weeklyDownloads",
        align: "right",
      },
    ];
    if (campaign) {
      continuousColumns.push({
        title: "CPM",
        render: renderToContext(<AverageCPM campaign={campaign} />),
        filterDropdown: "CPM",
        align: "right",
      });
    }

    const discreteColumns = [
      {
        title: "Episode Downloads",
        render: renderToContext(<EpisodeSize />),
        filterDropdown: "episodeDownloads",
        align: "right",
      },
    ];
    if (campaign) {
      discreteColumns.push({
        title: "Spot Rate",
        render: renderToContext(<SpotRate campaign={campaign} />),
        filterDropdown: "spotRate",
        align: "right",
      });
    }

    if (campaign?.distributionType === CampaignDistributionReachDiscrete) {
      Array.prototype.push.apply(commonColumns, discreteColumns);
    } else {
      Array.prototype.push.apply(commonColumns, continuousColumns);
    }
    additionalColumns && Array.prototype.push.apply(commonColumns, additionalColumns);
    return commonColumns;
  };

  additionalFilters = {
    minAverageCPM: 200,
    showSearchType: "ads",
    sortField: "estimatedWeeklyDownloads",
    ...(campaign?.targetingOptions && {
      adPositions: Object.keys(campaign.targetingOptions)
        .filter(key => campaign.targetingOptions[key])
        .join(","),
    }),
    ...additionalFilters,
  };
  return (
    <ShowSearch
      defaultShowExtraFilters={true}
      additionalFilters={additionalFilters}
      firstSearchFilters={{}}
      show
      columns={getColumns()}
      {...props}
    />
  );
};

export default AdvertiserSearch;
